<template>
  <div>
    <login-management />
    <system-management />
  </div>
</template>

<script>
import LoginManagement from "./LoginManagement";
import SystemManagement from "./SystemManagement";

export default {
  name: "SystemManagementIndex",
  data() {
    return {};
  },
  components: {
    LoginManagement,
    SystemManagement,
  },
};
</script>
